import { FC } from 'react';
import { useSelector } from 'react-redux';

import HtmlContent from '@components/HtmlContent/HtmlContent';
import { dashboardOrgDataSelector } from '@store/features/dashboardOrgInfo/selectors';

import './style.scss';

const InfoPage: FC = () => {
  const dashboardOrgInfo = useSelector(dashboardOrgDataSelector);

  const infoPageText = dashboardOrgInfo?.infoPageText;

  return (
    <div className="page info-page">
      {infoPageText && <HtmlContent>{infoPageText}</HtmlContent>}
    </div>
  );
};

export default InfoPage;
